import React from 'react';
import {connect} from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  withStyles} from '@material-ui/core';
import { Form } from 'react-final-form'
import { Field } from 'react-final-form-html5-validation';

import {togglePMChoiceWindow, toggleNewSepaWindow, toggleNewIngenicoWindow} from "./../../actions/PaymentActions";

import styles from "./customMaterialUIStyle"

@connect(store => {
	return {
    messages:store.messages.messages
}})

 class PaymentMethodChoiceDialog extends React.Component {

  openNewPMWindow = form => {
    const { dispatch } = this.props;
    const { paymentType } = form || {};
    if (paymentType === "SEPA") {
      dispatch(toggleNewSepaWindow(true))
    }else if (paymentType === "CARD") {
      dispatch(toggleNewIngenicoWindow(true))
    }
  }

  closePMChoiceDialog = () => {
    const { dispatch } = this.props;
    dispatch(togglePMChoiceWindow(false))
  }

  render() {
    const {classes, messages} = this.props;
    return (
      <div class="text-center">
        <Dialog
          open={true}
          aria-labelledby="simple-dialog-title"
          maxWidth="md"
          className={classes.width}
          >
            <DialogTitle id="form-dialog-title">{messages["common.label.update.payment.method"]}</DialogTitle>
            <DialogContent>
              <Grid>
                <label>{messages["common.label.update.payment.method.description"]}</label>
              </Grid>
              <Form onSubmit={this.openNewPMWindow} initialValues={{paymentType : "SEPA"}}
                  render={({handleSubmit, invalid, submitting}) => (
                    <form onSubmit={handleSubmit} className="content">
                      <Grid container direction="column">
                        <Grid item xs>
                          <label>
                            <Field
                              name="paymentType"
                              component="input"
                              type="radio"
                              value="SEPA"
                            />{' '}
                            {messages["common.label.by.sepa"]}
                          </label>
                        </Grid>
                        <Grid item xs>
                          <label>
                            <Field
                              name="paymentType"
                              component="input"
                              type="radio"
                              value="CARD"
                            />{' '}
                            {messages["common.label.by.card"]}
                          </label>
                        </Grid>
                        <Grid item xs className="text-right">
                          <Button 
                            className="btn btn-theme-standard"
                            variant="contained"
                            onClick={this.closePMChoiceDialog} >
                              {messages["common.button.cancel"]}
                          </Button>
                          <Button 
                            className={`btn btn-theme-default ${invalid || submitting ? "disabled-input" : ""}`}
                            type="submit" 
                            disabled={invalid || submitting}
                            variant="contained">
                              {messages["common.button.continue"]}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  )}
              />
            </DialogContent>
        </Dialog>

        </div>
      );
  }
}
export default withStyles(styles)(PaymentMethodChoiceDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/PaymentMethodChoiceDialog.jsx